// クラスの基礎力レベル(DA)のエンティティ
export class ClassBasicStrenghtLevel {
  // 先生ID DB型(*fk)
  public user_id?: string;
  // 基礎力項目 DB型(*varchar20)
  public strength_item?: string;
  static fromDB(record: { [column: string]: any; [column: number]: any }): ClassBasicStrenghtLevel {
    const entity = new ClassBasicStrenghtLevel();
    entity.user_id = record['user_id'];
    entity.strength_item = record['strength_item'];
    return entity;
  }
  static getTypeFitEntity(value: any): ClassBasicStrenghtLevel {
    const entity = new ClassBasicStrenghtLevel();
    entity.user_id = value.user_id;
    entity.strength_item = value.strength_item;
    return entity;
  }
}
